import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';

import { useDataService } from './ApiDataService';

const url = `/ipm/public/systemconfiguration`;

export const MIN_MAP_ZOOM = 2;
export const MAX_MAP_ZOOM = 18;
export const DEFAULT_MAX_MAP_ZOOM = 11;

export default function SystemConfigServiceFactory(dataService) {
    function getMaxMapZoom() {
        return dataService.get(`${url}/getMaxMapZoom`, {}).then((zoomConfig) => {
            let maxZoom = parseInt(zoomConfig.maxMapZoom, 10);
            if (_.isNaN(maxZoom) || maxZoom <= MIN_MAP_ZOOM || maxZoom > MAX_MAP_ZOOM) {
                maxZoom = DEFAULT_MAX_MAP_ZOOM;
            }
            return maxZoom;
        });
    }

    function getGeoJsonMapOverlay() {
        return dataService.get(`${url}/getGeoJsonMapOverlay`);
    }

    function getStandbyStatusInterval() {
        return dataService.get(`${url}/getStandbyStatusInterval`);
    }

    return {
        getMaxMapZoom,
        getGeoJsonMapOverlay,
        getStandbyStatusInterval,
    };
}

export function useSystemConfigService() {
    const dataService = useDataService();
    return useMemo(() => SystemConfigServiceFactory(dataService), [dataService]);
}

export function useMaxMapZoom() {
    const systemConfigService = useSystemConfigService();
    const [maxZoom, setMaxZoom] = useState(undefined);

    useEffect(() => {
        systemConfigService.getMaxMapZoom().then(setMaxZoom);
    }, [systemConfigService]);

    return maxZoom;
}

export function useGeoJsonMapOverlay() {
    const systemConfigService = useSystemConfigService();
    const [data, setData] = useState();
    useEffect(() => {
        systemConfigService.getGeoJsonMapOverlay().then((json) => setData(json));
    }, [systemConfigService]);
    return data;
}
